export interface FilterSettings {
  showNegativeSavings: boolean;
  showPositiveSavings: boolean;

  showApproved: boolean;
  showReview: boolean;
  showDisapproved: boolean;
  showNoDecision: boolean;

  showUnallocated: boolean;
  showLocked: boolean;
  showUnlocked: boolean;
  showDiscontinued: boolean;
  showNotDiscontinued: boolean;
  showDiscontinuedCrosses: boolean;
  showNotDiscontinuedCrosses: boolean;
  showUnpriced: boolean;
  showNotUnpriced: boolean;
  showUnpricedCrosses: boolean;
  showNotUnpricedCrosses: boolean;
  showFormularyPricing: boolean;
  showNonFormularyPricing: boolean;
  showIncludedInCompliance: boolean;
  showExcludedFromCompliance: boolean;

  //CrossType filter
  showSellerRecommendsPrimary: boolean;
  showSellerRecommendsAlternate: boolean;
  showSellerRecommendsSelfCross: boolean;
  showVizientCrossAttribute: boolean;
  showVizientCrossDerived: boolean;
  showBuyerRecommends: boolean;
  showIncumbentSelfCross: boolean;

  searchText: string;
  variance: number;

  // All of these are lists of particular things (for example, UNSPSC IDs).
  incumbentSellers: number[];
  crossesBySellers: number[];
  sellerIDs: number[];
  sellers: number[];
  unspscs: number[];

  // All of these are for the panels that open and close a part of the ppDetails
  sidebar: boolean;
  filtersToolbar: boolean;
  purchasePlanPanel: boolean;
  gridView: string;
}

export function generateDefaultFilters(): FilterSettings {
  return {
    showNegativeSavings: false,
    showPositiveSavings: false,

    showApproved: false,
    showDisapproved: false,
    showReview: false,
    showNoDecision: false,

    showUnallocated: false,
    showLocked: false,
    showUnlocked: false,
    showDiscontinued: false,
    showNotDiscontinued: false,
    showDiscontinuedCrosses: false,
    showNotDiscontinuedCrosses: false,
    showUnpriced: false,
    showNotUnpriced: false,
    showUnpricedCrosses: false,
    showNotUnpricedCrosses: false,
    showFormularyPricing: false,
    showNonFormularyPricing: false,

    showIncludedInCompliance: false,
    showExcludedFromCompliance: false,

    showSellerRecommendsPrimary: false,
    showSellerRecommendsAlternate: false,
    showSellerRecommendsSelfCross: false,
    showVizientCrossAttribute: false,
    showVizientCrossDerived: false,
    showBuyerRecommends: false,
    showIncumbentSelfCross: false,

    searchText: '',
    variance: 0,

    incumbentSellers: [],
    crossesBySellers: [],
    sellerIDs: [],
    sellers: [],
    unspscs: [],

    sidebar: false,
    filtersToolbar: false,
    purchasePlanPanel: true,
    gridView: 'default',
  };
}

/**
 * All of the various filters conform to this interface.
 */
export class FilterBase {
  needsSubset: boolean = false;
  skipIntersection: boolean = false;

  makeIndex(): any {
    return null;
  }

  getMatchSet(collection: any, filterSettings: FilterSettings): any {
    return null;
  }

  getCounts(filterCombinations: any): any {
    return {};
  }
}

////////////////////////////////////////////////////////////////////////////////
//                                      PourOver helpers for the various filters
////////////////////////////////////////////////////////////////////////////////
export function andIn(lhs: any, rhs: any) {
  if (rhs) {
    // A filter was specified. Let's see if we had already started filtering or not.
    if (lhs) {
      // Return a match set of the intersection of the two filters.
      return lhs.and(rhs);
    } else {
      // There was no existing filter, so just return the passed in filter, it's our starting point (or perhaps the only filter
      // we will be using).
      return rhs;
    }
  } else {
    // No filter was specified, return the original match set.
    return lhs;
  }
}

export function orIn(lhs: any, rhs: any) {
  if (rhs) {
    // A filter was specified. Let's see if we had already started filtering or not.
    if (lhs) {
      // Return a match set of the union of the two filters.
      return lhs.or(rhs);
    } else {
      // There was no existing filter, so just return the passed in filter, it's our starting point (or perhaps the only filter
      // we will be using).
      return rhs;
    }
  } else {
    // No filter was specified, return the original match set.
    return lhs;
  }
}

export function unionMembers(members: any, filter: any) {
  let union = null;

  // We can or together as many of these as the user wants to match. That results in one aggregate filter which
  // we add to our overall filter.
  members.forEach((unspsc) => {
    let memberFilter = filter.getFn(unspsc);

    if (union) {
      union = union.or(memberFilter);
    } else {
      union = memberFilter;
    }
  });

  return union;
}
